import { fetchApi } from '@/config/axiosSetting.ts';
import {
  GetDamagedVehicleCorrectiveImageTabsResponceType,
  GetDamagedVehicleCorrectiveImageTabsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImageTabs/getDamagedVehicleCorrectiveImageTabs.type';

export const getDamagedVehicleCorrectiveImageTabsFunction = (
  params?: GetDamagedVehicleCorrectiveImageTabsType,
): Promise<GetDamagedVehicleCorrectiveImageTabsResponceType> =>
  fetchApi({
    url: `/property/reports/${params?.id}/accident_users/damaged/images/corrective/entry_tabs/`,
    params: {
      damaged_id: params?.damaged_id,
    },
  });
